import { emarV2Constants } from 'locale/emarV2'

/** The add medication page's steps, in order. */
export const ADD_MEDICATION_STEPS = [
  {
    id: 'medicationAndScheduling',
    titleKey: emarV2Constants.ADD_MEDICATION_STEP_MEDICATION_AND_SCHEDULING
  },
  {
    id: 'instructions',
    titleKey: emarV2Constants.ADD_MEDICATION_STEP_INSTRUCTIONS
  },
  { id: 'details', titleKey: emarV2Constants.ADD_MEDICATION_STEP_DETAILS },
  { id: 'stock', titleKey: emarV2Constants.ADD_MEDICATION_STEP_STOCK },
  { id: 'overview', titleKey: emarV2Constants.ADD_MEDICATION_STEP_OVERVIEW }
] as const
